export const oidcConfig = {
  authority: process.env.REACT_APP_OIDC_AUTHORITY || 'https://q-accounts.qdx.global/realms/quidax',
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID || 'fe-client',
  redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI || window.location.origin + '/callback',
  post_logout_redirect_uri:
    process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI || window.location.origin + '/login',
  scope: process.env.REACT_APP_OIDC_SCOPE || 'openid profile email roles offline_access',
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: false,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};
